import React from 'react';

export function StepControlAuthoritiesLabel() {
  return <>Kompetentní kontrolní a ostatní orgány</>;
}
